/**
 * 会员信息
 */
import React from 'react';
import messager from '../../ui/messager';
import { Input, Row, Col, Button ,Select, Icon, Tooltip,DatePicker} from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth'
//详细信息展示
import BatchVehicleBillDetail from './BatchVehicleBillDetail';
//提前结算
import BatchVehicleBillEarly from './BatchVehicleBillEarly';


class BatchVehicleBillIndex extends React.Component {

    columns = [{
        title: '公司名称',
        dataIndex: 'projectId',
        width: '20%',
    }
    , {
        title: '月份',
        dataIndex: 'month',
        width: '6%',
    }
    ,{
        title: '开始时间',
        dataIndex: 'lastBillDate',
        width: '8%'
    }
    ,{
        title: '结束时间',
        dataIndex: 'currentBillDate',
        width: '8%'
    }
    ,{
        title: '总天数',
        dataIndex: 'dayNumbers',
        width: '8%',
    }
    ,{
        title: '单价/每车每天',
        dataIndex: 'unitPrice',
        width: '8%',
    }
    , {
        title: '金额',
        dataIndex: 'amount',
        width: '8%'
    }
    ,{
        title: '账单状态',
        dataIndex: 'status',
        width: '8%',
        format: { 0: '未收费', 1: '物管已收费',2:'财务已审核' }
    }
    , {
        title: '创建时间',
        dataIndex: 'createTime',
        width: '10%',
    }
    , {
        title: '创建人',
        dataIndex: 'creator',
        width: '8%'
    }
    ,{
        title: '操作',
        dataIndex: 'id',
        width: '8%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_PROJECT_RENT")&&record.status === 0?
                <Tooltip title="完成账单收费">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.collectFees.bind(this, text)} style={{ color: '#008000' }} />
                </Tooltip>
                : ''}
            </div>
        )
    }
];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false,
        visible: false,
        detailVisible: false,
        earlyVisible:false,
        billDetails:[],
        projectId:"",
        billId:""
    };

    create = () => {
        this.setState({ loadingVisible: true });
        http.post({
            url: '/barrier/batchVehicleBill/create',
            success: (res) => {
                this.setState({ loadingVisible: false });
                this.state.loadData(this.state.queryData);
                messager.notify("生成成功！");
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    delete = (info, e) => {
        messager.confirm("是否删除该账单？", () => {
            http.post({
                url: '/barrier/batchVehicleBill/delete',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //完成收费
    collectFees = (info, e) => {
        messager.confirm("是否完成该账单的收费？", () => {
            http.post({
                url: "/barrier/batchVehicleBill/status",
                data: { id: info, status: 1 },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("操作成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.projectId = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        queryData.month = dateString;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData["status"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //详情
    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        //读取竞价品信息
        http.get({
            url: '/barrier/batchVehicleBillDetail/page',
            data: { billId: info.id },
            success: (res) => {
                this.setState({ loadingVisible: false, detailVisible: true, billDetails: res, billId:info.id });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    //提前结算
    early = (info, e) => {
        this.setState({  earlyVisible: true  });
    }
   
    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="公司名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 320 }}
                                />
                                <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份" allowClear={false} style={{marginLeft: '10px' }} />
                                <Select onChange={this.selectChange} defaultActiveFirstOption allowClear={true} style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="0">未收费</Select.Option>
                                    <Select.Option value="1">物管已收费</Select.Option>
                                    <Select.Option value="2">财务已审核</Select.Option>
                                </Select>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_BILL_EARLY")?    
                                <Button type="primary" onClick={this.early} style={{ marginLeft: '20px'}}>提前结算</Button>
                                :""}
                                {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_BILL_CREATE")?
                                <Button type="primary" onClick={this.create} style={{ marginLeft: '20px'}}>生成本月账单</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/barrier/batchVehicleBill/page"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <BatchVehicleBillDetail
                    visible={this.state.detailVisible}
                    billId={this.state.billId}
                    onCancel={() => { this.setState({ detailVisible: false, billDetails: [] }) }}
                    billDetails={this.state.billDetails}
                />
                <BatchVehicleBillEarly
                    visible={this.state.earlyVisible}
                    onCancel={() => { this.setState({ earlyVisible: false, projectId: "" }) }}
                    projectId={this.state.projectId}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }
}

export default BatchVehicleBillIndex;